import Vue from 'vue'
import router from '@/router'
import {http as axios } from '@codium/codium-vue'
import auth from 'utils/auth'
import { has } from 'lodash'
import { notify } from 'utils'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

/**
 * Request interceptor that adds the JWT.
 */
axios.interceptors.request.use(config => {
  if (auth.getToken()) {
    config.headers.common['Authorization'] = `Bearer ${auth.getToken()}`
  }

  if (Vue.prototype.$echo) {
    config.headers.common['X-Socket-ID'] = Vue.prototype.$echo.socketId()
  }

  return config
})

/**
 * Request and response interceptor that refreshes JWT and will also kick us
 * back to login if the JWT expires.
 */
axios.interceptors.response.use(response => {
  if (has(response.headers, 'authorization')) {
    auth.updateTokenFromHeader(response.headers.authorization)
  }

  return response
}, error => {
  if (error.response && error.response.status === 401) {
    auth.redirectOnTokenExpired()

    if (has(error.response.data, 'error')) {
      return Promise.reject(error)
    }

    return Promise.reject(new Error('Authentication token has been expired. Re-authentication required.'))
  } else if (error.response && error.response.status === 403 && error.response.config.throwForbiddens !== true) {
    // For 403s we'll throw a blanket error notification and redirect them back to the dashboard.

    notify.error('You do not have permission to do that.')

    router.replace({ name: 'dashboard' })

    return Promise.reject(new Error('Forbidden'))
  } else {
    auth.updateTokenFromHeader(error.response.headers.authorization)
    return Promise.reject(error)
  }
})

// Setup the HTTP prototype on the Vue instance so we can access Axios
// much like how we access Vue Resource within our comnponents.
Vue.prototype.$http = axios

export default axios

/**
 * Generate URL to API.
 *
 * @return string
 */
export const apiUrl = (path) => {
  if (path === undefined) {
    return process.env.VUE_APP_API_URL
  }

  return `${process.env.VUE_APP_API_URL}/${path}?token=${auth.getToken()}`
}

export const publicUrl = (path) => {
  if (path === undefined) {
    return process.env.VUE_APP_PUBLIC_URL
  }

  return `${process.env.VUE_APP_PUBLIC_URL}/${path}`
}
